import { createContext } from "react";
import { createContextualCan } from "@casl/react";
import defineAbilitiesFor from "./Abilty";

const initialState = {
  create: false,
  publish: false,
  receive: false,
  submit: false,
};

const isGuest = false;

const AbilityContext = createContext(
  defineAbilitiesFor(initialState, isGuest, {}, null) // restrictionsPlan={}, company=null
);

// Avoid rendering <Context> directly (deprecated by React); bind to the Consumer instead.
export const Can = createContextualCan(AbilityContext.Consumer);

export default AbilityContext;
